import { AxiosRequestConfig } from "axios";
import {
    AuthConfig,
    Authenticator,
    COOKIE,
    X_AUTH_LENDSMART_COOKIE_EMAIL,
    X_AUTH_LENDSMART_NAMESPACE
} from './auth'
import { equals } from "ramda";
import { authenticatedUser } from "src/utilities/storage";
import { getNamespaceName } from "../objects/namespaces";


class CookieAuthenticator implements Authenticator {
    auth: AuthConfig;

    constructor(auth: AuthConfig) {
        this.auth = auth;
    }

    public isAuthProvider(): boolean {
        return equals(this.auth.provider, COOKIE)
    }

    public applyAuthentication(config: AxiosRequestConfig): AxiosRequestConfig {

        // When we enable withCredtials flag as true, default web browser will set cookie which sent by API server 
        return {
            ...config,
            headers: {
                ...config.headers,
                ...(authenticatedUser.accountEmail.get() && {
                    Content: 'application/json',
                    Accept: 'application/json',
                    [X_AUTH_LENDSMART_NAMESPACE]: getNamespaceName(),
                    [X_AUTH_LENDSMART_COOKIE_EMAIL]: authenticatedUser.accountEmail.get() || '',
                    'Access-Control-Allow-Origin': '*',
                }),
                withCredentials: true,
                responseType: 'json',
            },
        };
    }

    public shouldRefresh() {
        return false
    }

    public refreshAuthentication() {
        // Update session with latest token 
        return Promise.resolve()
    }
};

export {
    CookieAuthenticator
};